<template>
  <div class="profile-content-wrapper" v-if="!AUTH.isRequest">
    <div class="content-block">
      <div class="content-block__title">Безопасность</div>
      <div class="content-block__content">
        <div class="content-block__string input__hover" :class="{active: isEditPass}" v-click-outside="undoEditPassword">
          <div class="s1">Пароль</div>
          <label class="s2 input__label">
            <input
                ref="password"
                :type="passwordType"
                class="password"
                :class="{'password_warning': isEmptyDataPassword}"
                :placeholder="placeholderForPassword"
                :disabled="!isEditPass"
            >
            <svg v-if="!isPassShowed" @click="showHidePass" class="show__pass"
                 :class="{none_events: !isEditPass, visually_hidden: !isEditPass}" width="18" height="18"
                 viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <title>Показать текст пароля</title>
              <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#fafafa"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="#fafafa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else @click="showHidePass" class="show__pass"
                 :class="{none_events: !isEditPass, visually_hidden: !isEditPass}" width="18" height="18"
                 viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <title>Скрыть текст пароля</title>
              <path
                  d="M9.9 4.24002C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003L17.94 17.94Z"
                  stroke="#fafafa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1 1L23 23" stroke="#fafafa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </label>
          <div class="edit-button">
            <span v-if="!isEditPass" @click="editPass">Изменить</span>
            <span v-else-if="!showSpinner" @mousedown="savePass" v-html="this.passButtonText"></span>
            <spinner v-else/>
          </div>
        </div>
        <div class="content-block__string input__hover" :class="{active: isEditEmail}">
          <div class="s1">Email</div>
          <label class="s2">
            <input
                class="email"
                ref="email"
                :class="{'email_warning': isEmptyDataEmail}"
                :placeholder="placeholderForEmail"
                type="text"
                :value="USER.attributes.email === null ? '' : USER.attributes.email"
                :disabled="!isEditEmail"
                @blur="onBlurEmail"
                @focus="onFocusEmail">
          </label>
          <div class="edit-button">
            <span v-if="!isEditEmail" @click="editEmail">Изменить</span>
            <span v-else-if="!showSpinner" @mousedown="saveEmail" v-html="mailButtonText"></span>
            <spinner v-else/>
          </div>
        </div>

        <template>
          <div class="content-block__string input__hover" :class="{active: isEditPhone}"
               v-click-outside="undoEditPhone">
            <div class="s1">Номер телефона</div>
            <label class="s2 input__label">
              <input
                  ref="phone"
                  type="tel"
                  class="phone"
                  :class="{'password_warning': isEmptyDataPassword}"
                  :value="USER.attributes.phone | censor"
                  :disabled="!isEditPhone"
                  @keydown.enter="editOrSavePhone('edit')"
              >
            </label>
            <div class="edit-button">
              <span v-if="!isEditPhone" @click="editOrSavePhone('edit')">Изменить</span>
              <span v-else-if="!showSpinner" @mousedown="editOrSavePhone('save')" v-html="this.passButtonText"></span>
              <spinner v-else/>
            </div>
          </div>
          <div v-html="AUTH.errorText" class="error-text"></div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Spinner from "@/components/UIElements/spinner";
import profileSecurityPassword from "@/otherJS/mixins/profileSecurityPassword";
import profileSecurityEmail from "@/otherJS/mixins/profileSecurityEmail";


export default {
  name: "profileSecurity",
  components: {Spinner},
  mixins: [profileSecurityPassword, profileSecurityEmail],

  data() {
    return {
      isEditPhone: false,
      showSpinner: false,
      isPassShowed: false,
      passwordType: 'password'

      // showInput: false,
      // isBlockedUsersShow: false,
    }
  },
  computed: {
    ...mapGetters([
      'USER',
      'AUTH'
    ])
  },
  methods: {
    ...mapActions([
      'GET_SINGLE_USER',
      'UPDATE_USER_SECURITY_INFO'
    ]),
    undoEditPassword() {
      this.placeholderForPassword = '***********';
      this.$refs.password.value = '';
      this.isEditPass !== false ? this.isEditPass = false : true
      if (!this.isSavingPassword) {
        this.$refs.password.value = '';
        this.isEditPass = false;
      }
    },
    undoEditPhone() {
      this.isEditPhone = false;
    },
    editOrSavePhone(eventType) {

      switch(eventType) {
        case 'edit':
          this.isEditPhone = true;
          break;
        case 'save':
          this.showSpinner = true;

          let data = {
            type: 'phone',
            value: this.$refs.phone.value
          };
          this.UPDATE_USER_SECURITY_INFO(data).then(() => {

            this.showSpinner = false
            this.mailButtonText = '&#10004;&nbsp;Сохранено'
            setTimeout(() => {
              this.isEditPhone = false
              this.mailButtonText = 'Сохранить'
            }, 2000)

          })
          break;
        default:
          break;

      }

    },
    showHidePass() {
      this.isPassShowed = !this.isPassShowed;
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    }
    /*getUsersHeight: function () {
      let usersBlock = document.querySelector('.blocked_users__list');
      let blockedUsersHeight = this.isBlockedUsersShow === true ? usersBlock.scrollHeight : 0;
      usersBlock.style.maxHeight = blockedUsersHeight + 'px';
    }*/
  },
  mounted() {

  },
}
</script>

<style scoped lang="scss">
@import "src/scss/vars/colors";

.password, .email {
  &_warning {
    &::placeholder {
      opacity: .6;
      color: $red;
    }
  }
}

.spinner {
  &__wrap {
    margin-left: 25px;
  }
}

.dynamic-input {
  margin-left: -8px;
}

.blocked_users {
  &__text {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  &__list {
    width: 100%;
    padding-top: 24px;
    max-height: 0;
    overflow: hidden;
    transition: max-height .35s ease-out;

  }
}

.show_users {
  margin-left: 20px;
}

.security_check {
  @media (max-width: 580px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    .s2 {
      width: auto;
    }
  }
}

@media (max-width: 1366px) {
  .security_content {
    width: calc(100% - 270px);
  }
}

@media (max-width: 992px) {
  .security_content {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 580px) {
  .blocked_users {
    padding: 19px 16px 0 16px;
    background-color: rgba(#fff, .1);
    border-radius: 10px;

    &__text {
      display: block;
    }
  }
  .show_users {
    margin: 19px auto 0;
    width: fit-content;
  }
}

</style>
